import React, { Component } from 'react';

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import Fastbooking from '../components/fastbooking';
import Middlesection from '../components/middleSection'
import Footer from '../components/footer'
import SectionInformationBoxes from '../components/sectionInformationBoxes'

import SectionTable from './sectionTable'

class routeTable extends Component {
  render() {
    const city = this.props.city
    const isOrigin = this.props.isOrigin
    return (
      <div className='route-section-text'>
        <FirstHeader />
        <Header isMenu={true} />

        <Fastbooking color='white'/>
        <Middlesection section='table' />
        <SectionTable city={city} isOrigin={isOrigin}/>
        <SectionInformationBoxes/>

        <Footer />
      </div>
    );
  }
}

export default routeTable;



// WEBPACK FOOTER //
// ./src/shared/routes/routeTable/index.js